var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g, _g2, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormatBooklet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 40,
    height: 32,
    fill: "#A8A7CC",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 40,
    height: 32,
    fill: "#A8A7CC",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0V64",
    stroke: "#A8A7CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32H0",
    stroke: "#A8A7CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 0V64",
    stroke: "#A8A7CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0V64",
    stroke: "#A8A7CC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 12,
    height: 2,
    fill: "#52509A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 12,
    height: 2,
    fill: "#52509A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 8,
    height: 2,
    fill: "#52509A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 8,
    height: 2,
    fill: "#52509A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 4,
    width: 12,
    height: 2,
    fill: "#52509A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 12,
    width: 12,
    height: 2,
    fill: "#52509A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 8,
    width: 8,
    height: 2,
    fill: "#52509A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 16,
    width: 8,
    height: 2,
    fill: "#52509A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 44H6V52H14V44Z",
    stroke: "#52509A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 52L12 48L14 50",
    stroke: "#52509A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 44L11 49",
    stroke: "#52509A",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 44H46V52H54V44Z",
    stroke: "#52509A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 52L52 48L54 50",
    stroke: "#52509A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 44L51 49",
    stroke: "#52509A",
    strokeMiterlimit: 10
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 63,
    stroke: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatBooklet);
export default __webpack_public_path__ + "static/media/format-booklet.b816a06be744ebb3326e726e598322cb.svg";
export { ForwardRef as ReactComponent };